import * as React from "react";
import { useAvailableOptIns, useOptIns } from "@grandvisionhq/auth";
import { pushLoginExpressRememberUserDetailsClickEventToDataLayer } from "../../../../../../data-layer.js";
import { ConsentsContainer } from "../../../../../../modules/Consents/containers/modules/Consents/containers/ConsentsContainer.js";
import { OptInsContainer } from "../../../../../../modules/Consents/containers/modules/Consents/containers/OptInsContainer.js";
import { toSavedOptIns, getShownOptIns } from "../../../../../../modules/Consents/utils/modules/Consents/utils/opt-ins.js";
import { SaveDetailsToAccount } from "./SaveDetailsToAccount.js";
import { useLoggedInCheckout } from "../../../../../context/LoginExpressCheckout/context/context.js";
import { ImplicitTermsAndConditionsContainer } from "../../../../../../StepShipping/containers/StepShipping/containers/ImplicitTermsAndConditionsContainer.js";
import { ImplicitAccountCreationContainer } from "../../../../../../StepShipping/containers/StepShipping/containers/ImplicitAccountCreationContainer.js";
import { useCheckoutSettings } from "../../../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const ConsentsAndOptInsContainer = () => {
  const { availableOptIns } = useAvailableOptIns();
  const { optInsFromServer } = useOptIns();
  const { account, consent: consentSettings } = useCheckoutSettings();
  const {
    isSaveDetailsInAccount,
    setIsSaveDetailsInAccount,
    optIns: acceptedOptIns,
    consents,
    setOptIns,
    updateConsents,
    isUserLoggedIn
  } = useLoggedInCheckout();
  const allOptIns = consentSettings?.optIns || availableOptIns.filter((item) => item.isInSignup);
  const savedOptIns = React.useMemo(() => toSavedOptIns(optInsFromServer), [optInsFromServer]);
  const shownOptIns = React.useMemo(
    () => getShownOptIns(allOptIns, savedOptIns),
    [allOptIns, savedOptIns]
  );
  const selectedConsents = React.useMemo(
    () => consents?.filter((consent) => consent.isChecked),
    [consents]
  );
  const handleConsentChange = React.useCallback(
    (selectedConsents2) => {
      const consentList = consents.map((consent) => ({
        ...consent,
        isChecked: selectedConsents2.map((consent2) => consent2.value).includes(consent.value)
      }));
      updateConsents(consentList);
    },
    [consents, updateConsents]
  );
  const setConsents = React.useCallback(() => {
    updateConsents(
      consentSettings?.items?.map((consent) => {
        return { ...consent, isChecked: false };
      }) || []
    );
  }, [consentSettings?.items, updateConsents]);
  const onChangeHandler = React.useCallback(
    ({ isChecked }) => {
      setIsSaveDetailsInAccount(isChecked);
      pushLoginExpressRememberUserDetailsClickEventToDataLayer({ isLoggedIn: isUserLoggedIn });
    },
    [isUserLoggedIn, setIsSaveDetailsInAccount]
  );
  React.useEffect(() => {
    setConsents();
  }, [consentSettings?.items?.length]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SaveDetailsToAccount, { isChecked: isSaveDetailsInAccount, onChange: onChangeHandler }), /* @__PURE__ */ React.createElement(
    OptInsContainer,
    {
      optIns: shownOptIns,
      selectedOptIns: acceptedOptIns ?? [],
      onChange: setOptIns,
      isImplicitAccountCreation: account?.implicitAccountCreation
    }
  ), /* @__PURE__ */ React.createElement(
    ConsentsContainer,
    {
      consents,
      selectedConsents,
      onChange: handleConsentChange
    }
  ), /* @__PURE__ */ React.createElement(ImplicitTermsAndConditionsContainer, null), /* @__PURE__ */ React.createElement(ImplicitAccountCreationContainer, null));
};
export {
  ConsentsAndOptInsContainer
};
//# sourceMappingURL=ConsentsAndOptinsContainer.js.map
